import { render } from "./Campaign.vue?vue&type=template&id=5c5629ac&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5c5629ac"

export default script